export default __webpack_public_path__ + "static/media/we-all-deserve.ce3f5451.webp";